import {DayBar} from "./DayBar";
import React from "react";
import {GoalAlertTooltip} from "../../base/GoalAlertTooltip";
import {TYPE_CAMPAIGNS_CONFIGURATION} from "../../../DashboardRow";

export class GoalDayBar extends DayBar {
    baseCssClasses() {
        const base = `graphic-item`;
        if (this.props.isToday) {
            const fluctuationClass = `-${this.props.fluctuation}`;
            return `${base} -spotlight ${fluctuationClass}`;
        } else {
            return base;
        }
    }

    renderCellContent() {
        if(!this.props.isToday)
            return this.renderTooltip();

        if(this.props.rowType === TYPE_CAMPAIGNS_CONFIGURATION)
            return this.props.value;
        else
            return [this.props.fluctuationPercentage, this.renderTooltip()]
    }

    renderTooltip() {
        return <GoalAlertTooltip
            isToday={this.props.isToday}
            dayNumber={this.props.dayNumber}
            dayValue={this.props.dayValue}
            value={this.props.value}
            expectedValue={this.props.expectedValueOnDay}
            formattedGoalValue={this.props.formattedGoalValue}
            metricName={this.props.metricName}
            dayValueByType={this.props.dayValueByType}
            valueByType={this.props.valueByType}
            fluctuationPercentage={this.props.fluctuationPercentage}
            fluctuation={this.props.fluctuation}
            alertLevel={this.props.alertLevel.toLowerCase()}
            businessUnitId={this.props.businessUnitId}
            priority={this.props.priority}
        />;
    }


}
